import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {Paragraph} from '../paragraph';

/*
 * Props.
 */

interface DialogContentProps {
  className?: string;
}

/*
 * Style.
 */

const StyledWrapperDiv = styled.div`
  margin: 20px;
`;

const StyledParagraph = styled(Paragraph)`
  > ul,
  > ol {
    padding-left: 1.2em;
  }
`;

/*
 * Component.
 */

export const DialogContent: FC<PropsWithChildren<DialogContentProps>> = ({className, children}) => (
  <StyledWrapperDiv className={className}>
    <StyledParagraph>{children}</StyledParagraph>
  </StyledWrapperDiv>
);
